(function () {
  var input = document.getElementById('wc-search-input');
  var results = document.getElementById('wc-search-results');
  if (!input || !results) return;

  var timer;
  var activeIdx = -1;
  var items = [];
  var lastQuery = '';

  function hide() {
    results.hidden = true;
    items = [];
    activeIdx = -1;
    input.setAttribute('aria-expanded', 'false');
    input.removeAttribute('aria-activedescendant');
  }

  function imgSrc(url) {
    if (!url) return null;
    return url + (url.includes('?') ? '&' : '?') + 'width=112';
  }

  function formatPrice(cents) {
    if (cents === undefined || cents === null) return '';
    var num = parseFloat(cents);
    if (isNaN(num)) return '';
    return '$' + num.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function render(products) {
    if (!products.length) { hide(); return; }

    var html = '<div class="wc-search-header">Productos</div>';

    html += products.map(function (p, i) {
      var thumb = p.image
        ? '<img src="' + imgSrc(p.image) + '" width="56" height="56" loading="lazy" alt="">'
        : '<div class="wc-search-item__no-img"></div>';
      return '<a href="' + escapeHtml(p.url) + '" class="wc-search-item" id="wc-search-opt-' + i + '" data-idx="' + i + '" role="option">' +
        '<div class="wc-search-item__thumb">' + thumb + '</div>' +
        '<div class="wc-search-item__info">' +
          '<span class="wc-search-item__title">' + escapeHtml(p.title) + '</span>' +
          (p.price ? '<span class="wc-search-item__price">' + escapeHtml(p.price) + '</span>' : '') +
        '</div>' +
        '</a>';
    }).join('');

    html += '<a href="/search?q=' + encodeURIComponent(lastQuery) + '&type=product" class="wc-search-all">' +
      '<span>Ver todos los resultados de &ldquo;<strong>' + escapeHtml(lastQuery) + '</strong>&rdquo;</span>' +
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>' +
      '</a>';

    results.innerHTML = html;
    results.hidden = false;
    items = results.querySelectorAll('.wc-search-item');
    activeIdx = -1;
    input.setAttribute('aria-expanded', 'true');
    input.removeAttribute('aria-activedescendant');
  }

  var suggestController = null;

  function doFetch(q) {
    lastQuery = q;
    if (q.length < 2) { hide(); return; }
    // Cancelar la sugerencia anterior: sin esto una respuesta lenta y vieja
    // podia pisar a la del texto actual
    if (suggestController) suggestController.abort();
    suggestController = new AbortController();
    fetch(
      '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=6',
      { signal: suggestController.signal }
    )
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var prods = (data.resources && data.resources.results && data.resources.results.products) || [];
        render(prods.map(function (p) {
          return {
            url: p.url,
            title: p.title,
            image: p.image,
            price: formatPrice(p.price)
          };
        }));
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        hide();
      });
  }

  input.addEventListener('input', function () {
    clearTimeout(timer);
    var q = input.value.trim();
    if (q.length < 2) { hide(); return; }
    timer = setTimeout(function () { doFetch(q); }, 220);
  });

  /* Mostrar dropdown al re-enfocar si ya hay resultados */
  input.addEventListener('focus', function () {
    if (!results.hidden) return;
    var q = input.value.trim();
    if (q.length >= 2 && lastQuery === q) {
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }
  });

  input.addEventListener('keydown', function (e) {
    if (results.hidden || !items.length) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      activeIdx = Math.min(activeIdx + 1, items.length - 1);
      setActive();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      activeIdx = Math.max(activeIdx - 1, -1);
      setActive();
    } else if (e.key === 'Enter' && activeIdx >= 0) {
      e.preventDefault();
      items[activeIdx].click();
    } else if (e.key === 'Escape') {
      hide();
    }
  });

  function setActive() {
    Array.from(items).forEach(function (el, i) {
      el.classList.toggle('is-active', i === activeIdx);
      el.setAttribute('aria-selected', i === activeIdx ? 'true' : 'false');
    });
    if (activeIdx >= 0 && items[activeIdx]) {
      items[activeIdx].scrollIntoView({ block: 'nearest' });
      input.setAttribute('aria-activedescendant', items[activeIdx].id);
    } else {
      input.removeAttribute('aria-activedescendant');
    }
  }

  /* Botón submit: si el input está vacío solo enfoca, no redirige */
  var form = input.closest('form');
  if (form) {
    form.addEventListener('submit', function (e) {
      if (input.value.trim().length === 0) {
        e.preventDefault();
        input.focus();
      }
    });
  }

  document.addEventListener('click', function (e) {
    if (!results.hidden && form && !form.contains(e.target)) hide();
  });
})();
